import { render, staticRenderFns } from "./ActivityDetails.vue?vue&type=template&id=36ae0d80&scoped=true&"
import script from "./ActivityDetails.vue?vue&type=script&lang=js&"
export * from "./ActivityDetails.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDetails.vue?vue&type=style&index=0&id=36ae0d80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae0d80",
  null
  
)

export default component.exports